import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=2584b688&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=2584b688&prod&lang=scss&scoped=true"
import style1 from "./pay.vue?vue&type=style&index=1&id=2584b688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584b688",
  null
  
)

export default component.exports